import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import axios from 'axios';

const BookingConfirmed = () => {
  const location = useLocation();
  const { estimatedPrice, name, apartment, address, additionalAddress, fullName, mobileNumber } = location.state || {};
  const userEmail = localStorage.getItem('userEmail');
  const serviceUuid = sessionStorage.getItem('serviceUuid');

  useEffect(() => {
    const serviceUuid = sessionStorage.getItem('serviceUuid');
    if (serviceUuid) {
      const updateAddress = async () => {
        const token = localStorage.getItem('authToken');
        const addressData = {
          serviceRequestId: serviceUuid,
          locality: address,
          landMark: additionalAddress,
          zipCode: '',
          name: fullName,
          email: userEmail,
          mobileNo: mobileNumber,
          latititute: [],
          longitude: [],
          apartment: apartment,
        };

        const options = {
          method: 'PUT',
          url: `${process.env.REACT_APP_BACKEND_URL}:8899/booking-service/service-request/assign-address`,
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
          data: addressData,
        };

        try {
          const { data } = await axios.request(options);
          // console.log(data);
        } catch (error) {
          console.error(error);
        }
      };

      updateAddress();
    }
  }, [address, additionalAddress, fullName, mobileNumber, userEmail, apartment]);

  return (
    <div className="mt-6 w-full">
      <h1 className="text-4xl font-bold mb-2 text-[#101828]">Booking Confirmed</h1>
      <p className="text-lg text-[#475467] mb-10">
        Confirmation mail has been sent to your email. Please check.
      </p>

      <div className="bg-white p-4 rounded-lg mb-6 border border-[#EAECF0]">
        <h2 className="text-2xl font-bold mb-4">Booking Details</h2>
        <p className="mb-1">
          <span className="text-base text-[#475467]">Booking ID: </span>
          <span className="text-base font-semibold text-[#344054]">{serviceUuid}</span>
        </p>
        <p className="mb-1">
          <span className="text-base text-[#475467]">Your Issue: </span>
          <span className="text-base font-semibold text-[#344054]">Repair Phone {name}</span>
        </p>
        <p className="mb-4">
          <span className="text-base text-[#475467]">Estimated Amount: </span>
          <span className="text-base font-semibold text-[#344054]">AED {Math.round(estimatedPrice)}</span>
        </p>
      </div>

      <div className="bg-white p-4 rounded-lg border border-[#EAECF0]">
        <h2 className="text-2xl font-bold mb-4">Address and Additional Information</h2>
        <p className="mb-1 text-base text-[#475467] break-words">
          {apartment} , {address}, {additionalAddress}
        </p>
        <p className="text-base font-medium text-[#475467]">{fullName}</p>
        <p className="text-base font-medium text-[#475467] mb-4">{mobileNumber}</p>
      </div>
    </div>
  );
};

export default BookingConfirmed;
